<template>
  <div class="footer">
    <div class="content-w">
      <!-- S 友情链接 -->
      <Links/>
      <!-- E 友情链接 -->

      <!-- S 企业相关 -->
      <About/>
      <!-- E 企业相关 -->

      <!-- S 备案信息 -->
      <Copyright/>
      <!-- E 备案信息 -->
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import Links from './links.vue'
import About from './about.vue'
import Copyright from './copyright.vue'
export default {
  components: {
    Links,
    About,
    Copyright
  }

}
</script>

<style type="text/scss" lang="scss">
  .footer {
    background: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/footer/index.vue